<template>
    <section id="home" class="hero-section" aria-label="Início">
        <div class="hero-intro">
            <span class="hero-kicker">Tecnologia para operações complexas</span>
            <span class="hero-mark" aria-hidden="true">+</span>
            <h1 class="hero-title">Software sob medida para processos críticos.</h1>
            <p class="hero-subtitle">
                Desenvolvemos sistemas, automações e integrações para empresas que precisam transformar rotinas críticas
                em operações digitais seguras, rastreáveis e eficientes, independentemente do setor.
            </p>
            <div class="hero-actions">
                <button class="btn-primary" type="button" aria-label="Falar com especialista" @click="scrollToAnchor('contact')">
                    Falar com especialista
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                        <path d="M5 12h14M12 5l7 7-7 7" />
                    </svg>
                </button>
                <button class="btn-secondary" type="button" aria-label="Ver clientes" @click="scrollToAnchor('partners')">
                    Ver clientes
                </button>
            </div>
        </div>

        <div class="transition-zone">
            <aside class="hero-flow" aria-label="Fluxo de atuação da Mazzitech">
                <ol class="flow-list">
                    <li v-for="step in steps" :key="step.number">
                        <span>{{ step.number }}</span>
                        <strong>{{ step.title }}</strong>
                        <p>{{ step.description }}</p>
                        <div class="flow-visibility">
                            <b>Transparência</b>
                            <small>{{ step.transparency }}</small>
                        </div>
                    </li>
                </ol>
            </aside>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {
            steps: [
                {
                    number: "01",
                    title: "Diagnóstico técnico",
                    description: "Requisitos, sistemas envolvidos e pontos de integração.",
                    transparency: "Escopo validado, prioridades claras e próximos passos documentados.",
                },
                {
                    number: "02",
                    title: "Arquitetura da solução",
                    description: "Modelagem dos fluxos, dados, regras e interfaces.",
                    transparency: "Protótipos, decisões técnicas e critérios de aceite visíveis.",
                },
                {
                    number: "03",
                    title: "Desenvolvimento contínuo",
                    description: "Implementação, implantação, sustentação e evolução.",
                    transparency: "Entregas versionadas, status de evolução e acompanhamento constante.",
                },
            ],
        };
    },
    methods: {
        scrollToAnchor(anchor) {
            const section = document.getElementById(anchor);
            if (section) {
                section.scrollIntoView({ behavior: "smooth" });
            }
        },
    },
};
</script>

<style lang="scss">
.hero-section {
    position: relative;
    min-height: min(100vh, 980px);
    padding-top: 76px;
    background: #f7f7f5;
    color: #111111;
    overflow: visible;
    z-index: 1;
}

.hero-intro {
    width: 84vw;
    max-width: 1120px;
    margin: 0 auto;
    padding: clamp(46px, 5.2vh, 76px) 0 30px;
    text-align: center;
}

.hero-kicker {
    display: inline-flex;
    color: #242424;
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    opacity: 0;
    animation: hero-reveal 0.7s ease 0.1s forwards;
}

.hero-mark {
    display: block;
    margin: 18px auto 12px;
    color: #111111;
    font-size: 48px;
    font-weight: 800;
    line-height: 1;
    opacity: 0;
    animation: hero-reveal 0.7s ease 0.22s forwards;
}

.hero-section .hero-title {
    max-width: 1050px;
    margin: 0 auto;
    color: #111111 !important;
    font-family: "Space Grotesk", sans-serif !important;
    font-size: 92px !important;
    font-size: clamp(3.7rem, 6.4vw, 6.6rem) !important;
    font-weight: 700 !important;
    letter-spacing: 0 !important;
    line-height: 0.86 !important;
    opacity: 0;
    animation: hero-reveal 0.82s ease 0.34s forwards;
}

.hero-subtitle {
    max-width: 720px;
    margin: 26px auto 0;
    color: #555550;
    font-size: 18px;
    line-height: 1.76;
    opacity: 0;
    animation: hero-reveal 0.72s ease 0.48s forwards;
}

.hero-actions {
    display: flex;
    justify-content: center;
    gap: 12px;
    flex-wrap: wrap;
    margin-top: 22px;
    opacity: 0;
    animation: hero-reveal 0.72s ease 0.6s forwards;
}

.btn-primary,
.btn-secondary {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    min-height: 46px;
    padding: 13px 25px;
    border-radius: 999px;
    cursor: pointer;
    transition: border-color 0.25s ease, background 0.25s ease, color 0.25s ease;
    font-family: "Plus Jakarta Sans", sans-serif !important;
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.btn-primary {
    color: #ffffff !important;
    background: #0f4efb;
    border: 1px solid #0f4efb;
}

.btn-primary:hover {
    background: #0b3fd3;
    border-color: #0b3fd3;
}

.btn-secondary {
    color: #111111 !important;
    background: transparent;
    border: 1px solid #c7c7c2;
}

.btn-secondary:hover {
    color: #0f4efb !important;
    border-color: rgba(15, 78, 251, 0.45);
}

.transition-zone {
    position: relative;
    margin-top: 0;
    padding: 56px 0 0;
    background: #f7f7f5;
}

.hero-flow {
    position: relative;
    width: 84vw;
    max-width: 1120px;
    margin: 0 auto -122px;
    color: #111111;
}

.hero-flow::before {
    content: "";
    position: absolute;
    z-index: 0;
    top: 50%;
    left: 50%;
    width: 100vw;
    height: 10px;
    background: linear-gradient(90deg, #242424, #0f4efb 50%, #242424);
    transform: translate(-50%, -50%);
    background-size: 180% 100%;
    animation: flow-band 8s ease-in-out infinite;
}

.flow-list {
    position: relative;
    z-index: 1;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0;
    width: 100%;
    margin: 0;
    padding: 0;
    list-style: none;
    background: #ffffff;
    border: 1px solid #deded9;
    box-shadow: 0 18px 42px rgba(17, 17, 17, 0.08);
    opacity: 0;
    animation: flow-rise 0.82s ease 0.72s forwards;
}

.flow-list li {
    position: relative;
    min-height: 232px;
    padding: 34px 34px 28px;
    color: #111111;
    overflow: hidden;
    transition: background 0.3s ease, transform 0.3s ease;
}

.flow-list li + li {
    border-left: 1px solid #deded9;
}

.flow-list li::after {
    content: "";
    position: absolute;
    top: 58px;
    left: 78px;
    right: 34px;
    height: 1px;
    background: linear-gradient(90deg, #d0d0ca, rgba(15, 78, 251, 0.28), #d0d0ca);
    background-size: 220% 100%;
    animation: flow-line 5.8s ease-in-out infinite;
}

.flow-list li::before {
    content: "";
    position: absolute;
    z-index: 1;
    top: 51px;
    left: 34px;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    border: 1px solid #0f4efb;
    background: #ffffff;
    box-shadow: 0 0 0 8px rgba(15, 78, 251, 0.08);
    animation: flow-dot 4.8s ease-in-out infinite;
}

.flow-list li:nth-child(2)::before {
    animation-delay: 1.6s;
}

.flow-list li:nth-child(3)::before {
    animation-delay: 3.2s;
}

.flow-list li:hover {
    background: #fbfbfa;
    transform: translateY(-3px);
}

.flow-list span {
    display: block;
    color: #777771;
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 0.16em;
    margin-bottom: 30px;
}

.flow-list strong {
    display: block;
    color: #111111;
    font-family: "Space Grotesk", sans-serif !important;
    font-size: 22px;
    line-height: 1.05;
    margin-bottom: 10px;
}

.flow-list p {
    color: #555550;
    font-size: 14px;
    line-height: 1.55;
    margin: 0;
}

.flow-visibility {
    margin-top: 22px;
    padding-top: 16px;
    border-top: 1px solid rgba(15, 78, 251, 0.16);
}

.flow-visibility b,
.flow-visibility small {
    display: block;
}

.flow-visibility b {
    color: #0f4efb;
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 0.14em;
    line-height: 1;
    margin-bottom: 8px;
    text-transform: uppercase;
}

.flow-visibility small {
    color: #686864;
    font-size: 12px;
    line-height: 1.45;
}

@keyframes flow-dot {
    0%,
    100% {
        background: #ffffff;
        box-shadow: 0 0 0 8px rgba(15, 78, 251, 0.08);
    }
    18%,
    34% {
        background: #0f4efb;
        box-shadow: 0 0 0 10px rgba(15, 78, 251, 0.14);
    }
}

@keyframes flow-line {
    0%,
    100% {
        background-position: 0% 50%;
    }
    50% {
        background-position: 100% 50%;
    }
}

@keyframes flow-band {
    0%,
    100% {
        background-position: 0% 50%;
    }
    50% {
        background-position: 100% 50%;
    }
}

@keyframes hero-reveal {
    0% {
        opacity: 0;
        transform: translateY(18px);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes flow-rise {
    0% {
        opacity: 0;
        transform: translateY(28px);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

@media (prefers-reduced-motion: reduce) {
    .flow-list,
    .hero-actions,
    .hero-kicker,
    .hero-mark,
    .hero-section .hero-title,
    .hero-subtitle,
    .hero-flow::before,
    .flow-list li::after {
        opacity: 1 !important;
        transform: none !important;
        animation: none !important;
    }
}

@media (max-width: 960px) {
    .hero-section {
        min-height: auto;
        padding-top: 64px;
    }

    .hero-intro {
        width: 90%;
        padding: 32px 0 42px;
        text-align: left;
    }

    .hero-mark {
        margin-left: 0;
    }

    .hero-section .hero-title {
        font-size: 62px !important;
        font-size: clamp(3rem, 14vw, 4.8rem) !important;
    }

    .hero-subtitle {
        margin-left: 0;
    }

    .hero-actions {
        justify-content: flex-start;
    }

    .transition-zone {
        padding: 26px 0 0;
    }

    .hero-flow {
        width: 90%;
        margin-bottom: -258px;
    }

    .flow-list {
        grid-template-columns: 1fr;
        width: 100%;
        margin-top: 0;
        padding-top: 0;
    }

    .flow-list li + li {
        border-left: 0;
        border-top: 1px solid #deded9;
    }

    .flow-list li {
        min-height: 0;
        padding: 30px 26px 28px;
    }

    .flow-list li::after {
        top: 54px;
        left: 68px;
        right: 26px;
    }

    .flow-list li::before {
        top: 47px;
        left: 26px;
    }
}

@media (max-width: 520px) {
    .hero-section .hero-title {
        font-size: 52px !important;
        font-size: clamp(2.7rem, 14vw, 4rem) !important;
    }

    .hero-actions {
        flex-direction: column;
    }

    .btn-primary,
    .btn-secondary {
        width: 100%;
    }
}
</style>
